module.exports = __webpack_public_path__ + "img/지파이 하바네로(L).ce832fc8.jpg";